import { getFormattedFinance } from 'cng-common/helpers/numbers'

export const formatMdfContraPercent = (value: number | null): string =>
  value === null
    ? '—'
    : `${getFormattedFinance(value, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      })}%`
